module.exports = __webpack_public_path__ + "img/38777-123.550d5f9e.jpg";